<template>
  <v-card
    class="player-card blue-grey lighten-5"
    :class="{ 'player-card--selected': selected }"
  >
    <div :style="selected ? 'border-left: 5px solid #8A3E70 !important;' : ''">
      <v-overlay :value="playerStatus === 'ready'" absolute />

      <v-card-title
        :class="isConnected ? 'accent--text' : 'secondary--text'"
        class="headline justify-center"
        v-text="playerName"
      />

      <v-card-text class="text-center">
        <div
          :class="statusColor"
          class="mt-3 mb-2 py-3 rounded-pill subtitle-1 white--text lighten-1"
          v-text="$t(`animation.criticalchain.status.${playerStatus}`)"
        />
        <v-row
          v-if="criticalTaskList"
          no-gutters
          justify="center"
        >
          <v-col v-for="task in criticalTaskList" :key="task.id" cols="auto">
            <div
              class="rounded-lg white--text subtitle-1 px-2 py-1 ma-1"
              :style="`background-color: ${taskColors[task.color]}`"
              v-text="task.id"
            />
          </v-col>
          <v-col v-if="playerStatus === 'finished'" cols="auto">
            <div
              class="buffer rounded-lg grey--text text--darken-3 subtitle-1 px-2 py-1 ma-1"
              v-text="$t('animation.criticalchain.buffer', { size: value.bufferSize })"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'PlayerCard',
  props: {
    value: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    playerId () {
      return this.value.id
    },
    isConnected () {
      return this.value.playerName
    },
    playerName () {
      return this.isConnected
        ? this.value.playerName
        : this.$t('animation.criticalchain.notPlayerName')
    },
    playerStatus () {
      return this.value.status
    },
    statusColor () {
      return {
        ready: 'accent',
        canRemoveMultiTask: 'accent',
        canSelectCriticalChain: 'accent',
        canDefineBufferSize: 'accent',
        finished: 'success',
      }[this.playerStatus]
    },
    taskColors () {
      return {
        red: '#f9a240',
        blue: '#4772ff',
        green: '#37d852',
        brown: '#874a1b',
      }
    },
    criticalTaskList () {
      return ['canDefineBufferSize', 'finished'].includes(this.playerStatus)
        ? this.value.taskList
          .filter(task => task.isOnCriticalChain)
          .sort((a, b) => a.start.localeCompare(b.start))
        : undefined
    },
  },
}
</script>

<style lang="scss" scoped>
.player-card {
  overflow: hidden !important;
  transition: transform 0.1s linear !important;
  transition: box-shadow 0.1s linear !important;
  padding-left: 5px;
  padding-right: 5px;
}

.player-card--selected {
  transform: translateY(0px) scale(1.02) !important;
  box-shadow: 0 15px 15px rgba(0, 0, 0, 0.25) !important;
  padding-left: 0px;
}

.buffer {
  background: linear-gradient(
    340deg,
    rgba(25,210,116,1) 0%,
    rgba(226,228,60,1) 50%,
    rgba(214,21,21,1) 100%
  );
}
</style>
